<template>
    <div>
      <UsageReport v-if="project"/>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import UsageReport from '@/components/coding-admin/tags-usage-report.vue';
  export default {
    name: 'TagsUsageReport',
    components: {UsageReport},
    data: function() {
      return {
      }
    },
  
    mounted() {
      const projectUid = this.$route.params.project_uid;
      this.$emit('setHeaderPrimaryName', this.project.project_name);
      //this.$emit('setHeaderSecondaryName', 'Tags List');
    },
  
    computed: {
        ...mapState({
          user: state => state.user.user.data,
          project: state => state.projects.project.data
        }),
    },
  };
  </script>